// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Policy & legal settings  (route /policy/:slug — an extra legal document staff published, e.g. a quality policy)
// Shows the PUBLISHED version only; an unknown or unpublished slug is a normal 404. /terms and /privacy have their own routes (they fall back to the built-in text when nothing is published).
// Neighbours: components/PolicyText, hooks/usePublishedPolicy, pages/Policies (links to every published document), pages/admin/AdminPolicies.
// ─────────────────────────────────────────────────────────────────────────────
import { useParams } from "react-router-dom";
import PolicyPage, { PolicyLoading } from "../components/PolicyText";
import usePublishedPolicy from "../hooks/usePublishedPolicy";
import NotFound from "./NotFound";

export default function PolicyDocument() {
  const { slug = "" } = useParams();
  const published = usePublishedPolicy(slug);
  if (published.status === "loading") return <PolicyLoading />;
  return published.status === "ready" ? <PolicyPage doc={published.doc} /> : <NotFound />;
}
